export const DOMAIN_TYPE = 'aggregated';
